export type NewAsset = {
	type: number;
	originalFileName: string;
	contentType: string;
	fileData: string;
	fileExtension: string;
};

export enum AssetTypes {
    Avatar = 1
}
